<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="意向客户">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">意向城市</span>
                            <div class="input-condition">
                               <el-input placeholder="请输入内容" class="input-control" v-model="condition.city_name"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">来源渠道</span>
                            <div class="input-condition">
                                <el-select v-model="condition.channel_id" placeholder="请选择">
                                    <el-option v-for="item in channels" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">电话</span>
                            <div class="input-condition">
                                <el-input v-model="condition.client_mobile" placeholder="请输入电话"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">来源方式</span>
                            <div class="input-condition">
                                <el-select v-model="condition.source_id" placeholder="请选择">
                                    <el-option v-for="item in sources" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        
                        <div class="search-condition">
                            <span class="label">来源终端</span>
                            <div class="input-condition">
                                <el-select v-model="condition.terminal_id" placeholder="请选择">
                                    <el-option v-for="item in terminals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">报名时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.date"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        :picker-options="pickerOptions"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                      
                    </div>
                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="导出" placement="top">
                            <el-button icon="el-icon-download" @click="download"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <el-table-column  label="意向城市" prop="city_name"></el-table-column>
                    <el-table-column  label="公司名称" prop="client_company"></el-table-column>
                    <el-table-column  label="联系电话" prop="client_mobile"></el-table-column>
                    <el-table-column  label="姓名" prop="client_name"></el-table-column>
                    <el-table-column  label="电话归属地" prop="client_mobile_info"></el-table-column>
                    <el-table-column  label="来源渠道" prop="channel_name"></el-table-column>
                    <el-table-column  label="来源方式" prop="source_name"></el-table-column>
                    <el-table-column  label="客户端" prop="terminal_name"></el-table-column>
                    <el-table-column  label="报名时间" prop="created_at"></el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { getCustomers,getTerminals,getSources,getFormChannels  } from '@/service/customer'
    import { getInvestments  } from '@/service/investment'
    import { parseTime } from '@/utils'
    import {getUser} from '@/utils/auth'
    import { getSite, getSiteAreas } from '@/service/site'
    export default {
        name: "List",
        data () {
            return {
                condition : {
                    page :1,
                    per_page : 10,
                    total : 0,
                    city_name:'',
                    source_id : 0,
                    channel_id : 0,
                    terminal_id : 0,
                    client_mobile: '',
                    date : [],
                },
                sources : [
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                terminals : [
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                channels : [
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                list: [],
                isLoading: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                isShowMore: false
            }
        },
        computed: {
        },
        mounted () {
            this.getSources()
            this.getTerminals()
            this.getChannels()
            this.initData()
        },
        methods: {
            resetSearch(){
                this.condition = {
                    page :1,
                    per_page : 10,
                    total : 0,
                    city_name:'',
                    source_id : 0,
                    channel_id : 0,
                    terminal_id : 0,
                    client_mobile:'',
                    date : [],
                }
                this.initData()
            },
            getSources(){
                getSources({}).then((data) => {
                    this.sources = this.sources.concat(data)
                })
            },
            getTerminals(){
                getTerminals({}).then((data) => {
                    this.terminals = this.terminals.concat(data)
                })
            },
            getChannels(){
                getFormChannels({}).then((data) => {
                    this.channels = this.channels.concat(data)
                })
            },
            handleSearch() {
                this.condition.page = 1
                this.initData()
            },
            /** 初始化数据请求 */
            async initData () {
                this.list = []
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                let query = Object.assign({}, {}, this.condition)
                if (this.condition.date.length > 0) {
                    query.start_time = new Date(this.condition.date[0]).getTime()/1000
                    query.end_time = new Date(this.condition.date[1]).getTime()/1000
                }
                await getInvestments(query).then((data) => {
                    this.condition.total= parseInt(data.total)
                    this.condition.per_page = parseInt(data.per_page)
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        row.created_at = parseTime(new Date(row.created_at))
                    }
                    this.list = listData
                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            async download () {
                if (this.condition.date.length == 0) {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                import('@/vendor/Export2Excel').then(async excel => {
                    const tHeader=["意向城市","公司名称","联系电话","姓名","电话归属地","来源渠道","来源方式","客户端","报名时间" ]
                    const filterVal = ['city_name', 'client_company', 'client_mobile', 'client_name','client_mobile_info', 'channel_name', 'source_name', 'terminal_name', 'created_at']
                    let list = []
                    let query = {
                        export: 1,
                        per_page: 999,
                        city_name: this.condition.city_name,
                        source_id : this.condition.source_id,
                        channel_id : this.condition.channel_id,
                        terminal_id : this.condition.terminal_id,
                        client_mobile: this.condition.client_mobile,
                    }
                    if (this.condition.date.length > 0) {
                        query.start_time = new Date(this.condition.date[0]).getTime()/1000
                        query.end_time = new Date(this.condition.date[1]).getTime()/1000
                    }
                    this.isLoading = true
                    // 模拟fetch请求数据....
                    await getInvestments(query).then((data) => {
                        let listData = data.data
                        for (let i in listData) {
                            let row = listData[i]
                            row.created_at = parseTime(new Date(row.created_at))
                        }
                        list = listData
                    })
                    const formatJson = (filterVal) => {
                        return list.map(v => filterVal.map(j => {
                            return v[j]
                        }))
                    }
                    let name = '招商加盟意向客户'
                    if (this.condition.date.length > 0) {
                        name += parseTime( new Date(this.condition.date[0]), '{y}-{m}-{d}') + '至' + parseTime( new Date(this.condition.date[1]), '{y}-{m}-{d}')
                    }
                    const data = formatJson(filterVal)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: name
                    })
                    this.isLoading = false
                })
            },
            getExtraData (data) {
                if (data.length <= 0) return ''
                const extra = JSON.parse(data)
                if (extra.length <= 0) return ''
                return extra.map((v, i) => (i + ':' + v + '\n'))
            },
            currentChange (index) {
                this.condition.page = index
                this.initData()
            },
        }
    }
</script>
<style scoped lang="less">
</style>